import sendVerificationToken from './sendVerificationToken';
import verifyToken from './verifyToken';
import disableSmsTwoFactorAuth from './disableSmsTwoFactorAuth';

export default {
  sendVerificationToken,
  verifyToken,
  disableSmsTwoFactorAuth,
};



// WEBPACK FOOTER //
// ./src/app/services/smsTwoFactorAuthSetup/index.js